import { FC } from "react";
import { Flex, Heading, Spinner, Text } from "@radix-ui/themes";
import { Challenge } from "@/models/database/challenges/challenge.model";
import useGameInfo from "../../hooks/useGameInfo";
import { SubmitScoreForm } from "./SubmitScore.ui";

export const SubmitScoreGame: FC<Challenge> = ({ ...data }) => {
  const { gameData, loading, error } = useGameInfo(data.gameType);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!data) {
    return <div>No game found</div>;
  }

  if (!gameData) {
    return <div>No game data found</div>;
  }

  return (
    <Flex direction="column" gap="5">
      <Flex direction="column" gap="1">
        <Heading as="h1" mb="0">
          Submit your score for {data.name}
        </Heading>
        <Text size="2" color="gray">
          How well did you do? Submit your score and a screenshot as proof. Your
          score will go on the leaderboard once it is verified by a moderator.
        </Text>

        <SubmitScoreForm challengeData={data} gameData={gameData} />
      </Flex>
    </Flex>
  );
};
